import BsButton from "./BsButton";
import BsButtonToggle from "./BsButtonToggle";
import BsButtonToggleField from "./BsButtonToggleField";

export default Vue => {
    Vue.component(BsButton.name, BsButton);
    Vue.component(BsButtonToggle.name, BsButtonToggle);
    Vue.component(BsButtonToggleField.name, BsButtonToggleField);
};
